<template>
  <div class="pa-4 grid_config  justify-space-between" style="font-size: 26px">
    <div>{{ $props.title }}</div>
    <div class="grid_flex">
      <div>จำนวนรวม <b>{{ $props.price }}</b> {{ $props.type }}</div>
      <div>มูลค่ารวม <b>{{ $props.value }}</b> บาท</div>
    </div>
  </div>
</template>

<script>
import {formatPrice} from "@/js/handler";

export default {
  name: "BinTitle",
  props: ['title', 'price', 'type', 'value'],
  methods: {
    format_price: function(value) {
      return formatPrice(value)
    },
  },
}
</script>

<style scoped>
.grid_flex {
  display: flex;
  justify-content: space-between;
  text-align-all: right;
}
.grid_config {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media only screen and (max-width: 1024px){
  .grid_config {
    display: grid;
    grid-template-columns: 35% 65%;
  }
}
@media only screen and (max-width: 700px) {
  .grid_config {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
    font-size: 4.5vw;
  }
}
</style>
